import { format } from 'date-fns';
import React, { FunctionComponent, useState } from 'react';
import { Link } from 'react-router-dom';
import SideNav from './SideNav';
import FluxLogo from '../../flux-styles/flux-logo-white.svg';
import './Header.scss';
import { isDev, isLocal } from 'environment';

const Header: FunctionComponent = () => {
  const [showNav, setShowNav] = useState(false);
  return (
    <header className="header">
      <SideNav closeNav={() => setShowNav(false)} showNav={showNav} />
      <div className="header__left">
        <div
          className={
            showNav ? 'header__menu-button header__menu-button--active' : 'header__menu-button'
          }
          data-testid="menu-button"
          onClick={() => setShowNav(!showNav)}
          role="button"
        >
          Menu
        </div>
      </div>
      <div className="header__center">
        <Link className="apl-align-items-center apl-display-flex" to={'/'}>
          <img data-testid="flux-logo" alt="flux logo" src={FluxLogo} />
        </Link>
      </div>
      <div className="header__right">
        {isLocal() || isDev() ? (
          <a
            className="header__date-time"
            href={
              'https://git.fluxfederation.com/powerapps/commercial-industrial/-/environments?page=1&scope=available'
            }
            target="_blank"
          >
            Sandbox Deployment Info
          </a>
        ) : (
          <></>
        )}
        <div className="header__date-time">{format(new Date(), 'dd MMM yyyy')}</div>
      </div>
    </header>
  );
};

export default Header;
